import service from "@irati-tracking/tracker"

export enum WidgetViewType {
  Default = "Default",
  Filtered = "Filtered"
}

export enum WidgetFilterType {
  AdminWidgetDate = "AdminWidgetDate",
  AdminWidgetCountry = "AdminWidgetCountry",
  AdminWidgetCurrency = "AdminWidgetCurrency",
  AdminWidgetTeam = "AdminWidgetTeam"
}

const tracking = {
  editProfile: () => {
    service.trackEvent("admin_dashboard_edit_profile")
  },
  viewPeople: () => {
    service.trackEvent("admin_dashboard_view_people")
  },
  addSinglePerson: () => {
    service.trackEvent("admin_dashboard_add_single")
  },
  addBulkPeople: () => {
    service.trackEvent("admin_dashboard_add_bulk")
  },
  viewTeams: () => {
    service.trackEvent("admin_dashboard_view_teams")
  },
  addTeam: () => {
    service.trackEvent("admin_dashboard_add_team")
  },
  viewCustomisation: () => {
    service.trackEvent("admin_dashboard_view_customisation")
  },
  updateBrand: () => {
    service.trackEvent("admin_dashboard_update_brand")
  },
  addBenefit: () => {
    service.trackEvent("admin_dashboard_add_benefit")
  },
  perkVisibility: () => {
    service.trackEvent("admin_dashboard_perk_visibility")
  },
  viewRoles: () => {
    service.trackEvent("admin_dashboard_view_roles")
  },
  recognitionPermissions: () => {
    service.trackEvent("admin_dashboard_recognition_permissions")
  },
  viewLogin: () => {
    service.trackEvent("admin_dashboard_view_login")
  },
  enableSignUp: () => {
    service.trackEvent("admin_dashboard_ssu")
  },
  setUpSingleSignOn: () => {
    service.trackEvent("admin_dashboard_sso")
  },
  viewReports: () => {
    service.trackEvent("admin_dashboard_view_reports")
  },
  viewHelp: () => {
    service.trackEvent("admin_dashboard_view_help")
  },
  viewRegions: () => {
    service.trackEvent("admin_dashboard_viewregions")
  },
  viewRegionsTab: () => {
    service.trackEvent("admin_dashboard_navtab_regions")
  },
  viewPeopleTab: () => {
    service.trackEvent("admin_dashboard_navtab_people")
  },
  viewTeamsTab: () => {
    service.trackEvent("admin_dashboard_navtab_teams")
  },
  viewSettingsTab: () => {
    service.trackEvent("admin_dashboard_navtab_settings")
  },
  viewReportingTab: () => {
    service.trackEvent("admin_dashboard_navtab_reporting")
  },
  viewHelpTab: () => {
    service.trackEvent("admin_dashboard_navtab_help")
  },
  clickResourceHub: () => {
    service.trackEvent("admin_dashboard_resourceHub")
  },
  clickAddPeopleCTA: () => {
    service.trackEvent("admin_dashboard_addPeopleCTA")
  },
  clickCreateTeamsCTA: () => {
    service.trackEvent("admin_dashboard_createTeamsCTA")
  },
  clickAddRegionCTA: () => {
    service.trackEvent("admin_dashboard_addRegionCTA")
  },
  downloadPeopleList: () => {
    service.trackEvent("admin_dashboard_downloadPeopleList")
  },
  viewDetailedReports: () => {
    service.trackEvent("admin_dashboard_viewDetailedReports")
  },

  clickInviteAdmin: () => {
    service.trackEvent("admin_dashboard_onboarding_inviteAdmin")
  },
  clickCustomBrand: () => {
    service.trackEvent("admin_dashboard_onboarding_customBrand")
  },
  clickCustomEmail: () => {
    service.trackEvent("admin_dashboard_onboarding_customEmail")
  },
  clickEnableSSO: () => {
    service.trackEvent("admin_dashboard_onboarding_enableSSO")
  },
  clickInvitePeopleUpload: () => {
    service.trackEvent("admin_dashboard_onboarding_invitePeopleUpload")
  },
  clickInvitePeopleDSYNC: () => {
    service.trackEvent("admin_dashboard_onboarding_invitePeopleDSYNC")
  },
  clickCreateTeams: () => {
    service.trackEvent("admin_dashboard_onboarding_createTeams")
  },
  clickAssignManagers: () => {
    service.trackEvent("admin_dashboard_onboarding_assignManagers")
  },
  clickAddCustomBenefits: () => {
    service.trackEvent("admin_dashboard_onboarding_addCustomBenefits")
  },
  clickAddCompanyValues: () => {
    service.trackEvent("admin_dashboard_onboarding_addCompanyValues")
  },
  clickAddCompanyCelebrations: () => {
    service.trackEvent("admin_dashboard_onboarding_addCompanyCelebrations")
  },
  clickLinkPeopleDirectory: () => {
    service.trackEvent("admin_dashboard_onboarding_linkPeopleDirectory")
  },
  clickEditCultureHub: () => {
    service.trackEvent("admin_dashboard_onboarding_editCultureHub")
  },
  submitReasons: (reasons: string[]) => {
    service.trackEvent("admin_dashboard_integrationsModule_clickDontShowAgain_clickSubmitReasons", {reasons})
  },
  clickFindOutMore: () => {
    service.trackEvent("admin_dashboard_integrationsModule_clickFindOutMore")
  },
  clickReadLess: () => {
    service.trackEvent("admin_dashboard_integrationsModule_clickReadLess")
  },
  clickNotShowAgain: () => {
    service.trackEvent("admin_dashboard_integrationsModule_clickDontShowAgain")
  },
  clickGetStartedSSO: () => {
    service.trackEvent("admin_dashboard_integrationsModule_clickGetStartedSSO")
  },
  clickGetStartedDsync: () => {
    service.trackEvent("admin_dashboard_integrationsModule_clickGetStartedDsync")
  },
  closeIntegrationModule: () => {
    service.trackEvent("admin_dashboard_integrationsModule_clickClose")
  },
  clickSendInvites: () => {
    service.trackEvent("admin_dashboard_bulkResendInvite_confirmSend_send")
  },
  clickRemoveInvites: () => {
    service.trackEvent("admin_dashboard_bulkResendInvite_confirmSend_removeInvitees")
  },
  clickAddInvites: () => {
    service.trackEvent("admin_dashboard_bulkResendInvite_confirmSend_addInvitees")
  },
  openSendInviteModule: () => {
    service.trackEvent("admin_dashboard_bulkResendInvite_start")
  },
  closeSendInviteModule: () => {
    service.trackEvent("admin_dashboard_bulkResendInvite_confirmSend_exit")
  },
  clickSendInvitesTellMeMore: () => {
    service.trackEvent("admin_dashboard_bulkResendInvite_integrationsTellMeMore")
  },
  clickSendInvitesMaybeLater: () => {
    service.trackEvent("admin_dashboard_bulkResendInvite_integrationsMaybeLater")
  },
  confirmIntegrationModuleReminder: () => {
    service.trackEvent("admin_dashboard_integrationsModule_close_confirmReminder")
  },
  clickRewardWalletRewardsModal: () => {
    service.trackEvent("modal_click_reward_wallet")
  },
  clickOutRewardWalletRewardsModal: () => {
    service.trackEvent("modal_click_reward_wallet_close")
  },
  clickRewardsVideoRewardsModal: () => {
    service.trackEvent("modal_click_reward_video")
  },
  clickIntegrationSliderArrows: () => {
    service.trackEvent("admin_dashboard_integrationsModule_rotateValueStatements")
  },
  clickCatalogueSeeAllDeals: () => {
    service.trackEvent("admin_clickSeeAllDeals")
  },
  clickCatalogueSliderArrows: () => {
    service.trackEvent("admin_scroll_latestDealsAdded")
  },
  clickCatalogueDeal: () => {
    service.trackEvent("admin_clickedLatestDeal")
  },

  adminDashboardWidgets: (isFiltered?: boolean, filter?: WidgetFilterType[], action?: string) => {
    const viewType = isFiltered ? WidgetViewType.Filtered : WidgetViewType.Default
    const data = {
      source: "Navigation",
      product: "perkbox_insights_actions",
      action,
      viewType,
      filter
    }
    service.trackEvent("perkbox_insights_actions", data)
  },
  costOfLivingInsights: () => {
    const data = {
      source: "perkbox_insights_actions",
      product: "perkbox_insights_actions",
      action: "cta_unlockSavings",
      viewType: WidgetViewType.Default
    }
    service.trackEvent("cost_of_living_insights", data)
  },
  costOfLivingActions: (action?: string, isFiltered?: boolean, filter?: WidgetFilterType[]) => {
    const viewType = isFiltered ? WidgetViewType.Filtered : WidgetViewType.Default
    const data = {
      source: "perkbox_insights_actions",
      product: "cost_of_living_insights",
      action,
      viewType,
      filter
    }
    service.trackEvent("cost_of_living_actions", data)
  },
  recognitionInsights: (action?: string) => {
    const data = {
      source: "perkbox_insights_actions",
      product: "perkbox_insights_actions",
      action,
      viewType: WidgetViewType.Default
    }
    service.trackEvent("recognition_insights", data)
  },
  recognitionActions: (action?: string, isFiltered?: boolean, filter?: WidgetFilterType[]) => {
    const viewType = isFiltered ? WidgetViewType.Filtered : WidgetViewType.Default
    const data = {
      source: "recognition_insights_insights",
      product: "perkbox_insights_actions",
      action,
      viewType,
      filter
    }
    service.trackEvent("recognition_action", data)
  },
  valuesCelebrationsInsights: () => {
    const data = {
      source: "perkbox_insights_actions",
      product: "perkbox_insights_actions",
      action: "cta_createCulture",
      viewType: WidgetViewType.Default
    }
    service.trackEvent("value_celeb_insights", data)
  },
  valuesCelebrationsActions: (action?: string) => {
    const data = {
      source: "value_celeb_insights",
      product: "perkbox_insights_actions",
      action,
      viewType: WidgetViewType.Default
    }
    service.trackEvent("value_celeb_action", data)
  },

  companyBenefitsInsights: () => {
    const data = {
      source: "perkbox_insights_actions",
      product: "perkbox_insights_actions",
      action: "cta_promoteBenefits",
      viewType: WidgetViewType.Default
    }
    service.trackEvent("company_benefit_insights", data)
  },
  companyBenefitsActions: (action: string, filter?: WidgetFilterType[]) => {
    const viewType = filter?.length && filter.length > 0 ? WidgetViewType.Filtered : WidgetViewType.Default
    const data = {
      source: "company_benefit_insights",
      product: "perkbox_insights_actions",
      action,
      viewType,
      filter
    }
    service.trackEvent("company_benefit_action", data)
  },
  highestSavingPerksInsights: () => {
    const data = {
      source: "perkbox_insights_actions",
      product: "perkbox_insights_actions",
      action: "cta_viewReport"
    }
    service.trackEvent("highest_saving_insights", data)
  },
  wellnessInsights: () => {
    const data = {
      source: "perkbox_insights_actions",
      product: "perkbox_insights_actions",
      action: "cta_promoteWellness",
      viewType: WidgetViewType.Default
    }
    service.trackEvent("wellness_insights", data)
  },
  wellnessActions: (action: string) => {
    const data = {
      source: "wellness_insights",
      product: "perkbox_insights_actions",
      action,
      viewType: WidgetViewType.Default
    }
    service.trackEvent("wellness_action", data)
  },
  adminBenefits: (sub_product: string, action: string) => {
    const data = {
      product: "benefits",
      sub_product,
      action
    }
    service.trackEvent("adminBenefits", data)
  },
  adminBenefitsEnquiry: (sub_product: string) => {
    const data = {
      product: "benefits",
      action: "cta_submitEnquiry",
      sub_product
    }
    service.trackEvent("adminBenefits_enquiry", data)
  },
  adminDashboardOpenSendInviteModule: () => {
    const data = {
      source: "admin_notification",
      product: "benefits",
      action: "cta_resendEmail"
    }
    service.trackEvent("activation_resend_email", data)
  },
  adminNotificationPanelOrderManagement: () => {
    service.trackEvent("adminNotificationPanel_orderManagement")
  },
  adminNotificationPanelActivateUsersShareLink: () => {
    service.trackEvent("adminNotificationPanel_activatedUsersShareLink")
  },
  adminNotificationPanelActivateUsersSendEmail: () => {
    service.trackEvent("adminNotificationPanel_activatedUsersSendEmail")
  },
  adminNotificationPanelActivateUsersFallback: () => {
    service.trackEvent("adminNotificationPanel_activatedUsersFallback")
  },
  adminNotificationPanelUpcomingRenewal: () => {
    service.trackEvent("adminNotificationPanel_upcomingRenewal")
  },
  adminNotificationPanelEvergreenRenewal: () => {
    service.trackEvent("adminNotificationPanel_evergreenRenewal")
  },
  adminNotificationPanelReminderRenewal: () => {
    service.trackEvent("adminNotificationPanel_reminderRenewal")
  },
  adminNotificationPanelFileRecentlyUploaded: () => {
    service.trackEvent("adminNotificationPanel_fileRecentlyUploaded")
  },
  adminNotificationPanelRewardApprovals: () => {
    service.trackEvent("adminNotificationPanel_rewardApprovals")
  }
}

export default tracking
